"use client";

// src/components/accordion/accordion.tsx
import { ChevronDownMedium } from "@cat-home-experts/mortar-iconography-web/ChevronDownMedium";
import { useId, useState } from "react";
import { colors } from "../../themes/global-foundations.colors.mjs";
import { Heading } from "../heading/heading.mjs";
import { Text } from "../text/text.mjs";
import { accordionStyles } from "./accordion.styles.mjs";
import { jsx, jsxs } from "react/jsx-runtime";
var Chevron = ({ open }) => {
  const style = accordionStyles();
  return /* @__PURE__ */ jsx(
    ChevronDownMedium,
    {
      className: style.chevron({ open }),
      size: 20,
      color: colors.secondary.DEFAULT
    }
  );
};
var Accordion = ({
  title,
  subtitle,
  description,
  children,
  className,
  borders = "default",
  borderWidth = "default",
  startOpen = false,
  customOpenStyles = false,
  onClick
}) => {
  const [open, setOpen] = useState(startOpen);
  const id = useId();
  const labelId = useId();
  const style = accordionStyles();
  const toggle = () => {
    setOpen((isOpen) => !isOpen);
    if (onClick && !open) {
      onClick();
    }
  };
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: style.container({
        className: className?.container,
        borders,
        borderWidth,
        open,
        customOpenStyles: open && customOpenStyles
      }),
      children: [
        /* @__PURE__ */ jsxs(
          "button",
          {
            "aria-expanded": open,
            "aria-controls": id,
            className: style.titleContainer(),
            onClick: toggle,
            id: labelId,
            children: [
              /* @__PURE__ */ jsxs("div", { className: "pr-8", children: [
                subtitle && /* @__PURE__ */ jsxs(
                  "div",
                  {
                    className: style.titleWithSubtitle({
                      className: className?.title
                    }),
                    children: [
                      /* @__PURE__ */ jsx(Heading, { as: "h3", variant: "titleSM", weight: "semibold", children: title }),
                      /* @__PURE__ */ jsx(Text, { as: "p", variant: "labelMD", className: style.subtitle(), children: subtitle })
                    ]
                  }
                ),
                !subtitle && /* @__PURE__ */ jsx("div", { className: style.title({ className: className?.title }), children: title }),
                description && !open && /* @__PURE__ */ jsx(Text, { as: "p", variant: "labelMD", className: style.description(), children: description })
              ] }),
              /* @__PURE__ */ jsx(Chevron, { open })
            ]
          }
        ),
        /* @__PURE__ */ jsx(
          "div",
          {
            id,
            className: style.contentWrapper({
              open,
              className: className?.contentWrapper
            }),
            hidden: !open,
            role: "region",
            "aria-labelledby": labelId,
            children: /* @__PURE__ */ jsx(
              "div",
              {
                className: style.contentOverflow({
                  className: className?.contentOverflow
                }),
                children: /* @__PURE__ */ jsx("div", { className: style.content({ className: className?.content }), children: typeof children === "function" ? children({ toggle, open }) : children })
              }
            )
          }
        )
      ]
    }
  );
};
export {
  Accordion
};
